import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const LinkUI = styled(Link)`
  width: 150px;
  height: 40px;
`;
export const BtnUI = styled.button`
  background-color: ${(props) => (props.inverted ? "var(--red)" : "inherit")};
  font-size: 16px;
  border: 1px solid var(--red);
  border-radius: 20px;
  text-decoration: none;
  color: ${(props) => (props.inverted ? "var(--white)" : "var(--red)")};
  font-family: var(--roboto);
  width: 150px;
  height: 40px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 1000px) {
    &:hover {
      transition: all 0.2s ease-in;
      background-color: ${(props) =>
        props.inverted ? "var(--white)" : "var(--red)"};
      color: ${(props) => (props.inverted ? "var(--red)" : "var(--white)")};
    }
  }
`;

const Button = ({ text, path, inverted }) => {
  return (
    <LinkUI to={path || "./"}>
      <BtnUI inverted={inverted}> {text} </BtnUI>
    </LinkUI>
  );
};

export default Button;
